import React from 'react';
import { ButtonGroup, Button } from '@mui/material';
import { TableChart, Timeline } from '@mui/icons-material';
import { useFilters } from 'components/Elements/Filters/FilterContext';

const ViewToggle = ({ onViewChange }) => {
	const { filterValues, updateFilter } = useFilters();
	
	// Get current view from filter state
	const currentView = filterValues.viewToggle?.value?.id || 'table';

	const handleViewChange = (newView) => {
		// Update the filter framework state
		const newViewValue = {
			id: newView,
			name: newView === 'table' ? 'Table View' : 'Gantt View'
		};
		
		updateFilter('viewToggle', newViewValue, { view: newView });

		// Call the original onViewChange handler if provided
		onViewChange?.(newView);
	};

	return (
		<ButtonGroup size="small" aria-label="view toggle">
			<Button
				onClick={() => handleViewChange('table')}
				variant={currentView === 'table' ? 'contained' : 'outlined'}
				sx={{
					minWidth: '80px',
					backgroundColor: currentView === 'table' ? 'rgb(48,122,215)' : 'transparent',
					'&:hover': {
						backgroundColor: currentView === 'table' ? 'rgb(48,122,215)' : 'rgba(48,122,215,0.1)'
					}
				}}
			>
				<TableChart sx={{ mr: 0.5 }} />
				Table
			</Button>
			<Button
				onClick={() => handleViewChange('gantt')}
				variant={currentView === 'gantt' ? 'contained' : 'outlined'}
				sx={{
					minWidth: '80px',
					backgroundColor: currentView === 'gantt' ? 'rgb(48,122,215)' : 'transparent',
					'&:hover': {
						backgroundColor: currentView === 'gantt' ? 'rgb(48,122,215)' : 'rgba(48,122,215,0.1)'
					}
				}}
			>
				<Timeline sx={{ mr: 0.5 }} />
				Gantt
			</Button>
		</ButtonGroup>
	);
};

export default ViewToggle;